import gql from 'graphql-tag'
import _ from 'lodash'

export default config => async (payload = {}) => {
  const {
    client,
    table,
    defaultPageSize,
    defaultOrderBy,
    defaultSearchBy,
    defaultFilters,
    defaultOutput,
    defaultFragments,
    fetchPolicy,
    alias = 'items'
  } = config

  let {
    needle = null,
    page = 1,
    pageSize = defaultPageSize,
    searchBy = defaultSearchBy,
    output = defaultOutput,
    fragments = defaultFragments || '',
    filters = defaultFilters,
    orderBy = defaultOrderBy
  } = payload

  const query = gql`
          query(
            $limit: Int
            $offset: Int
            $order_by: [${table}_order_by!]
            $filters: ${table}_bool_exp!
          ) {
            ${alias}: ${table}(
              order_by: $order_by
              limit: $limit
              offset: $offset
              where: {
                _and: [
                  $filters
                ]
              }
            ) {
                ${output}
            }
            meta: ${table}_aggregate(
              where: {
                _and: [
                  $filters
                ]
              }
            ) {
              pagination: aggregate {
                total_rows: count
              }
            }
          }
          ${fragments}
    `

  let searchFilter = buildSearchFilter({ needle, fields: searchBy })
  if (searchFilter) filters = [...filters, { _or: [...searchFilter] }]

  let variables = {
    offset: pageSize === -1 ? null : (page - 1) * pageSize,
    limit: pageSize === -1 ? null : pageSize,
    order_by: orderBy,
    filters: !_.isEmpty(filters) ? { _and: [...filters] } : null
  }

  let { data } = await client.query({
    fetchPolicy,
    query,
    variables
  })

  return {
    [alias]: data.items,
    total_rows: data.meta.pagination.total_rows
  }
}

const buildSearchFilter = ({ needle, fields }) => {
  // skip if field or needle is empty or undefined
  if (_.isEmpty(fields) || _.isEmpty(needle)) return

  const filter = { _ilike: `%${needle}%` }
  let result = []
  for (const field of fields) {
    if (typeof field === 'string') {
      result.push({ [field]: filter })
    } else if (typeof field === 'object')
      for (const key of Object.keys(field)) {
        result.push({
          [key]: { _or: buildSearchFilter({ needle, fields: field[key] }) }
        })
      }
  }

  return result
}
